enum PresenceStatus {
  ONLINE = 'online',
  OFFLINE = 'offline',
  AWAY = 'away',
  DND = 'dnd',
  UNAVAILABLE = 'unavailable',
}

export default PresenceStatus;
